const API_REGION_TOKEN = 'xref-api-region';
// The JWT auth token
const AUTH_TOKEN = 'xrefauthtoken';

const QUESTIONNAIRE_TOKEN = 'xrefquestionnairetoken';

const AUTH_DOMAIN_WHITELIST = [
  new RegExp(/^.+\.?xref\.com$/),
  'localhost:8000',
  '127.0.0.1:8000',
  'xref.localhost:9000',
  'xref.localhost:3001',
];

// Tracking ID
const TRACKING_ID = 'xreftrackingid';

// Used for I18N, sets the default(/fallback) language
const LOCALE = 'en-au';

// The key used for localStorage, must be consistent in all apps with i18n enabled
const LOCALE_TOKEN = 'xref-chosen-locale';

const REGISTER_SESSION_TOKEN = 'lite-register-session';

// Used for I18N, dictates which languages are available to the app
const SUPPORTED_LOCALES = [
  {label: 'English (AU)', key: 'en-au'},
  {label: 'English (UK)', key: 'en-gb'},
  {label: 'English (CA)', key: 'en-ca'},
  {label: 'English (US)', key: 'en-us'},
  {label: 'Français (CA)', key: 'fr-ca'},
  {label: 'Svenska', key: 'sv-se'},
  {label: 'Norsk (Bokmål)', key: 'nb-no'},
  {label: 'Suomi', key: 'fi-fi'},
  {label: 'Dansk', key: 'da-dk'},
  {label: 'Deutsch', key: 'de-de'},
  {label: 'Español', key: 'es-es'},
  {label: 'Español (US)', key: 'es-us'},
  {label: '简体中文', key: 'zh-cn'},
  {label: 'Polski', key: 'pl-pl'},
  {label: 'Italiano', key: 'it-it'}
];

const APP_ROUTE_PATHS = {
  getStarted: 'get-started',
  build: 'build/:id',
  savedToXref: 'saved-to-xref',
  sentToEmail: 'sent-to-email',
  maintenance: 'maintenance',
  oauthConnect: 'oauth/connect'
};

const BASE_SCROLLBAR_CONFIG = {
  suppressScrollX: true,
  maxScrollbarLength: 30,
  minScrollbarLength: 30
};

const OAUTH_LOGIN_PATH = 'oauth/questionnaire/';

// Key of the return url cookie after user authorises through Oauth
const OAUTH_RET_URL_KEY = 'xrefquestionnaireoauthreturnurl';

const OAUTH_SAVE_ON_RETURN = 'xrefquestionnaireoauthsaveonreturn';

// Xref contrast setting
const CONTRAST = 'xrefcontrast';

// Exporting a set of constants allows these unchanging values to be parsed around the app as a singleton service
export default {
  AUTH_TOKEN,
  TRACKING_ID,
  QUESTIONNAIRE_TOKEN,
  LOCALE,
  LOCALE_TOKEN,
  REGISTER_SESSION_TOKEN,
  SUPPORTED_LOCALES,
  AUTH_DOMAIN_WHITELIST,
  APP_ROUTE_PATHS,
  BASE_SCROLLBAR_CONFIG,
  OAUTH_LOGIN_PATH,
  OAUTH_RET_URL_KEY,
  OAUTH_SAVE_ON_RETURN,
  CONTRAST,
  API_REGION_TOKEN
};
